import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CommonPopup } from "../../util/common";
import { AUDIO_FAILED } from "../../util/constants";
import { getNoCacheCall } from "../../util/resources";
import SesHeader from "../header";

const AudioTest = () => {
    const [audioPlaying, setAudioPlaying] = useState(false);
    const [popupData, setpopupData] = useState({
        isOpen: false,
        popupHeader: "",
        popupBody: "",
        popupFooter: "",
    });
    const location = useLocation();
    const phrases = location.state.user.siteConfig.phrases;
    const navigate = useNavigate();
    const [isAudioLoaded, setIsAudioLoaded] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const audioRef = useRef(null);
    const header = useRef({
        "x-xpert-session": location.state.user.sessionId,
        "Content-Type": "application/json",
    });

    const nextNavigate = (hasAudio = false) => {
        if (hasAudio) {
            sessionStorage.setItem(
                `${location.state.user.sessionId}hasAudio`,
                true
            );
        }
        navigate("/langTest", {
            state: location.state,
        });
    };

    const exitTest = async () => {
        try {
            const response = await getNoCacheCall(
                AUDIO_FAILED + location.state.test.id,
                header.current
            );
            if (response.data) {
                if (response.data.errors) {
                    const errorMsg = response.data.errors.join("<br/>");
                    setpopupData((prev) => {
                        prev = {
                            ...prev,
                            isOpen: true,
                            popupHeader: "",
                            popupBody: errorMsg,
                            popupFooter: phrases?.["10928"],
                        };
                        return prev;
                    });
                } else {
                    navigate("/langTest", {
                        state: { ...location.state, test: response.data },
                    });
                }
            } else {
                navigate("/");
            }
        } catch (error) {
            console.error("error trying to replace test;");
        }
    };

    const closePopUp = () => {
        setpopupData((prev) => {
            prev = { ...prev, isOpen: false };
            return prev;
        });
    };

    const approveAction = async () => {
        navigate("/");
    };

    const handleLoadedData = () => {
        setIsAudioLoaded(true);
        setIsLoading(false);
    };

    const handlePlayButtonClick = (e) => {
        e.preventDefault();
        if (audioRef.current) {
            if (isAudioLoaded) {
                if (audioPlaying) {
                    handleAudioPlay(true);
                } else {
                    handleAudioPlay();
                }
            } else {
                setIsLoading(true);
                audioRef.current.load();
                handleAudioPlay();
            }
        }
    };
    const handleAudioPlay = (stopped = false) => {
        if (stopped) {
            setAudioPlaying(false);
            audioRef.current.pause();
        } else {
            setAudioPlaying(true);
            audioRef.current.play();
        }
    };

    useEffect(() => {
        if (location.state.user.inBranch === true) {
            nextNavigate();
        } else if (
            location.state.test.audioFile === false ||
            sessionStorage.getItem(`${location.state.user.sessionId}hasAudio`)
        ) {
            nextNavigate();
        }
    }, []);

    return (
        <>
            <div className="g-container flex_col p4 g5 pt0_mobile g2_mobile full-width">
                <SesHeader clientCobranding={location.state.cobrandingLink} />
                <div className="flex_col g2">
                    <h3>{phrases?.["15034"]}</h3>
                    <div className="base">{phrases?.["15035"]}</div>
                </div>
                <div className="flex_col flex_gsb g2">
                    <div
                        className="p2 roundness_1 border_tt82"
                        style={{ width: "fit-content" }}
                    >
                        <audio
                            ref={audioRef}
                            preload="auto"
                            loop
                            onCanPlay={handleLoadedData}
                        >
                            <source
                                src="/multimedia/sounddetect/sounddetect.mp3"
                                type="audio/mpeg"
                            />
                            <source
                                src="/multimedia/sounddetect/sounddetect.ogg"
                                type="audio/ogg"
                            />
                        </audio>
                        {
                            <button
                                className="button-icon_large"
                                iconPosition="left"
                                onClick={(e) => handlePlayButtonClick(e)}
                            >
                                {isLoading ? (
                                    "Loading..."
                                ) : (
                                    <span className="material-icons">
                                        {audioPlaying
                                            ? "stop_circle"
                                            : "play_arrow"}
                                    </span>
                                )}
                            </button>
                        }
                    </div>
                </div>
                <hr />
                <div className="flex_col_reverse_mobile flex_row align-items_center justify-content_between g2">
                    <button
                        className="button-secondary text_uppercase full-width_mobile"
                        onClick={exitTest}
                    >
                        {phrases?.["14393"]}
                    </button>
                    <button
                        className="button-primary text_uppercase full-width_mobile"
                        onClick={nextNavigate}
                    >
                        {phrases?.["14392"]}
                    </button>
                </div>
            </div>
            <CommonPopup
                popupData={popupData}
                closeAction={closePopUp}
                approveAction={approveAction}
                setterFun={setpopupData}
            />
        </>
    );
};

export default AudioTest;
